import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsWorkloadRoute: InvariantJiraRoute = {
	name: 'servicedesk-reports-workload',
	path: '/jira/servicedesk/projects/:projectKey/reports/workload',
	exact: true,
};
